import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API } from "./api";

const SESSION_KEY = "sufi_session_id";

const getSessionId = () => {
  let s = localStorage.getItem(SESSION_KEY);
  if (!s) {
    s = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(SESSION_KEY, s);
  }
  return s;
};

export const useAnalytics = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const send = async () => {
      try {
        await fetch(`${API}/analytics/visit`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            path: pathname,
            referrer: document.referrer || "",
            session_id: getSessionId(),
          }),
        });
      } catch (err) {
        // Non-blocking — analytics failure must not affect UX
        if (process.env.NODE_ENV !== "production") {
          console.debug("Analytics visit failed:", err);
        }
      }
    };
    send();
  }, [pathname]);
};
